/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var ErrorDark = function ErrorDark(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Error state icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['icon--error--linear-gradient--example-error-button', 'icon--error--linear-gradient-2--example-error-button', 'icon--error--linear-gradient-3--example-error-button'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--error--linear-gradient--example-error-button'],
    x1: "38.91",
    x2: "38.91",
    y1: "77.08",
    y2: "8.15",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--error--linear-gradient-2--example-error-button'],
    x1: "12.43",
    x2: "76.33",
    y1: "10.8",
    y2: "47.7",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".52",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".61",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".99",
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--error--linear-gradient-3--example-error-button'],
    x1: "39.38",
    x2: "52.04",
    y1: "31.37",
    y2: "9.45",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".11",
    stopColor: "#6f6f6f",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".94",
    stopColor: "#6f6f6f"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M59.91 78.34l-43-24.83 4.86-2.8 43 24.82-4.86 2.8z",
    opacity: ".25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--error--linear-gradient--example-error-button'], ")"),
    d: "M38.98 6.92C51.13 13.94 60.94 30.94 60.9 44.9s-9.92 19.6-22.07 12.58S16.87 33.46 16.91 19.5 26.83-.1 38.98 6.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--error--linear-gradient-2--example-error-button'], ")"),
    d: "M42.85 4.68C36.74 1.15 31.2.82 27.2 3.15l-3.66 2.13c3.98-2.2 9.43-1.83 15.44 1.64C51.13 13.94 60.94 30.94 60.9 44.9c-.02 6.76-2.35 11.57-6.13 13.93l-.07.05c-.32.2 3.66-2.1 3.66-2.1 3.95-2.3 6.4-7.19 6.41-14.12C64.81 28.7 55 11.69 42.85 4.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['icon--error--linear-gradient-3--example-error-button'], ")"),
    d: "M29.11 3.9v.37a19.58 19.58 0 019.68 2.97c12.03 6.94 21.78 23.84 21.74 37.65-.02 9.4-4.56 15.23-11.83 15.23a19.59 19.59 0 01-9.68-2.96C26.99 50.22 17.24 33.32 17.28 19.5c.02-9.39 4.56-15.22 11.83-15.22V3.9m0 0c-7.2 0-12.17 5.7-12.2 15.59-.04 13.96 9.77 30.97 21.92 37.98a20.03 20.03 0 009.87 3.01c7.2 0 12.17-5.7 12.2-15.6.04-13.95-9.77-30.96-21.92-37.97A20.03 20.03 0 0029.1 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M38.93 49.8a6.84 6.84 0 01-2.66-2.52 6.07 6.07 0 01-.81-3v-.98a2.25 2.25 0 01.81-2.05q.81-.52 2.66.55a6.72 6.72 0 012.6 2.5 6.04 6.04 0 01.82 2.98v.99a2.25 2.25 0 01-.82 2.05c-.54.34-1.4.17-2.6-.53zm-1.16-11.64l-1.75-15.39v-9.73l5.81 3.36v9.73l-1.66 13.42z"
  }));
};
ErrorDark.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var ErrorDark$1 = ErrorDark;

export { ErrorDark$1 as default };
